import React from 'react';
import {LandingPage} from './container';

export const LandingScreen = ({navigation}: {navigation: any}) => {
  return <LandingPage />;
};
